import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { WorkActivityService } from 'app/management/actionTypes/workActivity-service';
import { CommonService } from 'app/reusable/common.service';
import { UserProfile } from 'app/_models';
import { AuthenticationService } from 'app/_services';
import { CedConfirmDialogService, CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { environment } from "environments/environment";
import { takeUntil } from 'rxjs/operators';
import { CedProductService } from '../ced-product.service';
import { CedProductModel } from '../models/ced-product.model';

@Component({
  selector: 'app-ced-product-details',
  templateUrl: './ced-product-details.component.html',
  styleUrls: ['./ced-product-details.component.scss']
})
export class CedProductDetailsComponent extends DialogContentBase  implements OnInit, OnDestroy {
  public cedProductForm = new FormGroup({});
  private _subject$: Subject<boolean> = new Subject();
  private selectedItem : CedProductModel = null;
  public selectedWorkActivity: any;
  private profile: UserProfile = new UserProfile();
  values = [{text:"Yes",id:0},{text:"No",id:1}];
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  workActivityData = [];
  workActivityList = [];

  constructor( dialog: DialogRef,
    private cedProductService : CedProductService,
    private cedNotificationService: CedNotificationService,
    private workActivityService:WorkActivityService,
    private authenticationService: AuthenticationService,
    private commonService: CommonService,
    private cedConfirmService: CedConfirmDialogService) {
      super(dialog);
      this.setProfile(); 
    }

  ngOnInit() {       
    this.initForm();
    this.getWorkActivityClientTasks()
  }

  getWorkActivityClientTasks(){        
    this.workActivityService
    .getworkActivityClientTasks()
    .pipe(takeUntil(this._subject$))
    .subscribe((data : any) => {
      data.forEach(element => {
        let workActivityItem ={
          workActivityName : element.waCode + "-" + (element.waShortName?element.waShortName:element.waLongName),
          workActivityId : element.waId
        }
        this.workActivityData=[...this.workActivityData,workActivityItem]
      });
      this.populateControls();
    });
}

  setProfile() {
    let _currentUser = this.authenticationService.currentUserValue;
    this.profile.fullName = _currentUser.name;
    this.profile.emailAddress = _currentUser.unique_name;
    this.profile.familyName = _currentUser.family_name;
    this.profile.givenName = _currentUser.given_name;
    this.profile.ipAddress = _currentUser.ipaddr;
  }

  initForm(){
    this.cedProductForm = new FormGroup({
        code: new FormControl(null, Validators.required),
        shortName: new FormControl(null, Validators.required),
        longName: new FormControl(null, Validators.required),
        active: new FormControl(null, Validators.required),
        workActivity : new FormControl(null)
    });
  }

  populateControls(){
    if(this.selectedItem != null){
        this.cedProductForm.controls.code.setValue(this.selectedItem.prdCode);
        this.cedProductForm.controls.shortName.setValue(this.selectedItem.prdShortName);
        this.cedProductForm.controls.longName.setValue(this.selectedItem.prdLongName);
        if(this.selectedItem.prdInactive == true){
          this.cedProductForm.controls.active.setValue(this.values[1]);
        }else if(this.selectedItem.prdInactive == false){
          this.cedProductForm.controls.active.setValue(this.values[0]);
        }
        if(this.selectedItem.productWorkActivities.length>0){
          this.selectedItem.productWorkActivities.forEach(e=>{
            let workActivityItem = {
              workActivityName:(this.workActivityData.find(w=> w.workActivityId ==e.pwaWorkActivityId))?(this.workActivityData.find(w=> w.workActivityId ==e.pwaWorkActivityId)).workActivityName:null,
              workActivityId:e.pwaWorkActivityId}      
            this.workActivityList = [...this.workActivityList,workActivityItem]
          })
        }
    }                                       
  }

  public save() {
    let product = new CedProductModel ();                
    product.prdCode = this.cedProductForm.controls.code.value;
    product.prdShortName = this.cedProductForm.controls.shortName.value;
    product.prdLongName =  this.cedProductForm.controls.longName.value;
    product.prdInactive =  this.cedProductForm.controls.active.value.id;
    if(this.workActivityList.length > 0 ){
      this.workActivityList.forEach(e=>{
        product.productWorkActivities.push({pwaWorkActivityId:e.workActivityId})
      })
    };
    if(this.cedProductForm.valid){
      if(this.workActivityList.length > 0 ){
        if(this.selectedItem == null){
          product.prdCreatedBy = this.profile.emailAddress;          
          product.prdLastModifiedBy = this.profile.emailAddress;      
          this.cedProductService
          .addCedProduct(product)
          .pipe(takeUntil(this._subject$))
          .subscribe(
            (res:any) => {
              let existingCode = res;
              if (existingCode == true)
              {
                this.cedNotificationService.error("NOTIFICATIONS.PRODUCT_CODE_SHOULD_BE_UNIQUE")
              }
              else if (existingCode == false) {
                this.dialog.close(true);
                this.cedNotificationService.success("NOTIFICATIONS.SAVE_SUCCEDED");
              }
            }
          )
      }
      else{
        product.prdId = this.selectedItem.prdId;
        product.prdLastModifiedBy = this.profile.emailAddress;
        this.cedProductService
        .update(product)
        .pipe(takeUntil(this._subject$))
        .subscribe(
          (res:any) => {
            let existingCode = res;
            if (existingCode == true)
            {
              this.cedNotificationService.error("NOTIFICATIONS.PRODUCT_CODE_SHOULD_BE_UNIQUE")
            }
            else if (existingCode == false) {
              this.dialog.close(true);
              this.cedNotificationService.success("NOTIFICATIONS.UPDATE_SUCCEDED");
            }
          }
        )
      }
      }
      else if(this.workActivityList.length == 0 ){
        this.cedNotificationService.error("NOTIFICATIONS.WORK_ACTIVITY_SHOULD_BE_ADDED");
      }
    } 
    else
    this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
}

addWorkActivity(workActivity){
  if(workActivity.value != "" && this.workActivityList.some(e=>e ==workActivity.value) == false )
  this.workActivityList = [...this.workActivityList,workActivity.value]
  this.cedProductForm.controls["workActivity"].setValue(null);
}

get workActivityValue(){
  return this.cedProductForm.controls["workActivity"].value;
}

changeActiveStatus(event){
  if(this.selectedItem != null){
    if(event && event.id == 1){
      let GetCaseTypesUrl: string = `CaseType/GetAll`;
      this.commonService.getData(GetCaseTypesUrl, this.serverUrlSlot3)
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          let associatedCaseType = data.some(item=>item.ctyDossierProductId == this.selectedItem.prdId && item.ctyIsActive == true);
          if(associatedCaseType == true){
            this.cedNotificationService.warning("NOTIFICATIONS.A_CED_PRODUCT_CAN_ONLY_BE_MADE_INACTIVE_IF_THERE_ARE_NO_ASSOCIATED_CASE_TYPES_ASSOCIATED_TO_IT");
            if(this.selectedItem.prdInactive == true){
              this.cedProductForm.controls.active.setValue(this.values[1]);
            }else if(this.selectedItem.prdInactive == false){
              this.cedProductForm.controls.active.setValue(this.values[0]);
            }
          }else{
            this.cedProductForm.controls.active.setValue(event);
          }
        });
    }
  }
}


public delete(item) {
  this.cedConfirmService.show('ARE_YOU_SURE_YOU_WANT_TO_CONTINUE?').pipe(takeUntil(this._subject$)).subscribe(res => {
    if (res.value) {
      this.workActivityList = [...this.workActivityList.filter((e) => e != item)];
    }
  });
}

public cancel() {
  this.dialog.close(null);
}   

ngOnDestroy(): void {
  this._subject$.next();
  this._subject$.complete();
}
}